import React from 'react'

import { useAuth } from 'src/modules/auth'
import { SecondaryNavLayout } from 'src/modules/ui'

import EnvironmentSelector from './EnvironmentSelector'
import RecipeListView from './views/RecipeListView'
import IngredientListView from './views/IngredientListView'
import CreateRecipeFormView from './views/CreateRecipeFormView'
import JobTypeListView from './views/JobTypeListView'
import EquipmentTypeListView from './views/EquipmentTypeListView'
import CreateIngredientFormView from './views/CreateIngredientFormView'
import EditIngredientFormView from './views/EditIngredientFormView'
import RecipeDetailView from './views/RecipeDetailView'
import CategoryListView from './views/CategoryListView'
import EditRecipeFormView from './views/EditRecipeFormView'

const Recipes = () => {
  const { user } = useAuth()

  const routes = [
    {
      navLabel: 'Recipes',
      path: '/recipes',
      exact: true,
      component: RecipeListView,
    },
    {
      navLabel: 'Ingredients',
      path: '/recipes/ingredients',
      exact: true,
      component: IngredientListView,
    },
    {
      navLabel: 'Job Types',
      path: '/recipes/job-types',
      exact: true,
      component: JobTypeListView,
    },
    {
      navLabel: 'Equipment Types',
      path: '/recipes/equipment-types',
      exact: true,
      component: EquipmentTypeListView,
    },
    {
      navLabel: 'Categories',
      path: '/recipes/categories',
      exact: true,
      component: CategoryListView,
    },
  ]

  // Non Nav Routes
  routes.push(
    ...[
      {
        path: '/recipes/create',
        component: CreateRecipeFormView,
        title: 'Create a new Recipe',
      },
      {
        path: '/recipes/:id/edit',
        component: EditRecipeFormView,
        title: 'View Recipe',
      },
      {
        path: '/recipes/detail/:id',
        component: RecipeDetailView,
        title: 'View Recipe',
      },
      {
        path: '/recipes/ingredient/:id/edit',
        component: EditIngredientFormView,
        title: 'Edit an Ingredient',
      },
      {
        path: '/recipes/ingredient/create',
        component: CreateIngredientFormView,
        title: 'Create a new Ingredient',
      },
    ]
  )

  let extraControl
  if (user.organisation.environmentCount > 1) {
    extraControl = <EnvironmentSelector />
  }

  return <SecondaryNavLayout extraControl={extraControl} routes={routes} />
}

export default Recipes
